<script setup>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";

import { initServicePopups } from "@/components/useServicePopups";
import { useAppStore } from "@/stores";

import SvgIcon from "./SvgIcon.vue";

const store = useAppStore();
const router = useRouter();

const showServices = ref(false);
const openServices = ref(() => {});

const message = computed(() =>
  store.isRetryingConnection ? "Connection lost. Retrying…" : "Connection lost.",
);

onMounted(() => {
  const popups = initServicePopups();
  showServices.value = popups.showServices;
  openServices.value = popups.openServices;
});
</script>

<template>
  <Transition name="slide">
    <div v-if="store.crossNotAvailable" class="banner" role="status">
      <SvgIcon name="system/alert-triangle" class="icon" width="16" height="16" />
      <span class="text">{{ message }}</span>
      <button type="button" class="link" @click="router.go()">Refresh</button>
      <button v-if="showServices" type="button" class="link" @click="openServices">
        Open services
      </button>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;
@use "@/styles/mixins/typography";

.banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 32px;
  padding: 0 16px;
  line-height: 1;
  color: c.$text-inverse;
  background-color: c.$brand-danger;
  white-space: nowrap;

  @include typography.small("regular");
}

.icon {
  color: c.$text-inverse;
  flex-shrink: 0;
}

.text {
  @include typography.small("medium");
}

.link {
  padding: 0;
  font: inherit;
  color: c.$text-inverse;
  opacity: 0.85;
  background: none;
  border: 0;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 1;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition:
    transform 0.25s ease,
    opacity 0.25s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
</style>
